export default "__VITE_ASSET__d75f4d5f__"